import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select/select.component';
import { pretailoringPageMessages } from '@/pages/pre-tailoring/pre-tailoring.messages';
import React from 'react';
import { useIntl } from 'react-intl';

interface FilterInputOption {
  value: string;
  label: React.ReactNode;
  testId: string;
}

interface Props {
  onFilterChange: (value: string) => void;
  value?: string;
  options: FilterInputOption[];
}

export const FilterInput = ({ onFilterChange: handleFilterChange, value, options, ...props }: Props) => {
  const t = useIntl();

  return (
    <Select value={value} data-testid="filter-bar" onValueChange={handleFilterChange}>
      <SelectTrigger data-testid="filter-bar-trigger" className="w-[180px] mr-4" {...props}>
        <SelectValue
          data-testid="filter-bar-value"
          placeholder={t.formatMessage(pretailoringPageMessages.questionFilterPlaceholder)}
        />
      </SelectTrigger>
      <SelectContent>
        {options.map((option) => (
          <SelectItem key={option.value} data-testid={option.testId} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
